import { __assign, __generator, __spreadArray } from "tslib";
import { put, takeLatest, call, select, takeEvery, all, delay, } from 'redux-saga/effects';
import findIndex from 'lodash/findIndex';
import findLastIndex from 'lodash/findLastIndex';
import { request } from '../xhr';
import { changeOrder, threadUpdated, initializeThread, streamIdChanged, fetchNextInThread, fetchPreviousInThread, } from './actionCreators';
import { selectors, actions, withCursor } from '../Stream';
import { getStreamId, updateCommentOffset } from './helpers';
import { getCurrentUserCommentsOrder, getIsMobile, } from '../publicSession/selectors';
import { updateCommentsOrder } from '../publicSession/actions';
import { THREAD_MAX_DEPTH, THREAD_MAX_DEPTH_MOBILE, COMMENT_THREAD_STREAM_GROUP_ID, DEFAULT_ITEMS_PER_FETCH, } from './constants';
import { getThreadState } from './selectors';
function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                errorDescription: 'Not logged in.',
                status: 'error',
            };
        }
        // eslint-disable-next-line
        var Fake = require('@wix/da-sample-data').Fake;
        var fakeThread = Fake.makeCommentThread(48, false);
        fakeThread.cursor =
            fakeThread.thread[fakeThread.thread.length - 1]['commentId'];
        if (options.params.order === 'oldest') {
            var fake = __assign({}, fakeThread);
            fake.thread = __spreadArray([], fakeThread.thread, true);
            fake.thread.reverse();
            return fake;
        }
        return fakeThread;
    }
}
/**
 * TODO this should probably be the selector and also better to have stream type in
 * streamParams and check that...
 * @param streamId
 */
function getStreamParams(streamId) {
    var streamParams, commentableTypeId, commentableItemId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 1:
                streamParams = _a.sent();
                if (!streamParams) {
                    return [2 /*return*/, false];
                }
                commentableTypeId = streamParams.commentableTypeId, commentableItemId = streamParams.commentableItemId;
                if (!commentableTypeId || !commentableItemId) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, streamParams];
        }
    });
}
function fetchThreadWithCursor(_a, cursor, limit) {
    var params, result;
    var commentableTypeId = _a.commentableTypeId, commentableItemId = _a.commentableItemId, parentId = _a.parentId, order = _a.order, maxDepth = _a.maxDepth;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                params = {
                    typeid: commentableTypeId,
                    itemid: commentableItemId,
                    parentid: parentId,
                    maxdepth: maxDepth,
                    order: order,
                    cursor: cursor,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: '/comments/thread',
                        params: params,
                    }, fakeResponse)];
            case 1:
                result = _b.sent();
                return [2 /*return*/, result];
        }
    });
}
function fetchMoreCommentsWithCursor(_a) {
    var streamParams, _b, cursor, limit, result;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, delay(300)];
            case 1:
                _c.sent();
                return [4 /*yield*/, call(getStreamParams, streamId)];
            case 2:
                streamParams = _c.sent();
                return [4 /*yield*/, select(function (state) { return ({
                        cursor: withCursor.selectors.getCursor(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 3:
                _b = _c.sent(), cursor = _b.cursor, limit = _b.limit;
                return [4 /*yield*/, call(fetchThreadWithCursor, streamParams, cursor, limit)];
            case 4:
                result = _c.sent();
                if (!!result) return [3 /*break*/, 6];
                // TODO: request does not return error message atm
                return [4 /*yield*/, put(withCursor.actions.fetchFailure({ streamId: streamId, errorMsg: 'Failed to fetch' }))];
            case 5:
                // TODO: request does not return error message atm
                _c.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(withCursor.actions.fetchSuccess({
                    streamId: streamId,
                    hasMore: !!result.hasMore,
                    items: result.thread,
                    cursor: result.cursor || undefined,
                }))];
            case 7:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function fetchPreviousComments(_a) {
    var streamParams, _b, cursor, limit, result;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, delay(300)];
            case 1:
                _c.sent();
                return [4 /*yield*/, call(getStreamParams, streamId)];
            case 2:
                streamParams = _c.sent();
                return [4 /*yield*/, select(function (state) { return ({
                        cursor: withCursor.selectors.getPrevCursor(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 3:
                _b = _c.sent(), cursor = _b.cursor, limit = _b.limit;
                return [4 /*yield*/, call(fetchThreadWithCursor, streamParams, cursor, limit)];
            case 4:
                result = _c.sent();
                if (!!result) return [3 /*break*/, 6];
                // TODO: request does not return error message atm
                return [4 /*yield*/, put(withCursor.actions.fetchFailure({ streamId: streamId, errorMsg: 'Failed to fetch' }))];
            case 5:
                // TODO: request does not return error message atm
                _c.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(withCursor.actions.fetchPreviousSuccess({
                    streamId: streamId,
                    hasLess: !!result.hasLess,
                    items: result.thread,
                    prevCursor: result.prevCursor || undefined,
                }))];
            case 7:
                _c.sent();
                if (result.thread.length > 0) {
                    updateCommentOffset(result.thread[0]);
                }
                return [2 /*return*/];
        }
    });
}
function switchStreamOrder(action) {
    var _a, streamId, order, streamParams, itemsPerFetch, result, newStreamParams;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                _a = action.payload, streamId = _a.streamId, order = _a.order;
                return [4 /*yield*/, call(getStreamParams, streamId)];
            case 1:
                streamParams = _b.sent();
                if (!streamParams) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(selectors.getItemsPerFetch, streamId)];
            case 2:
                itemsPerFetch = _b.sent();
                return [4 /*yield*/, call(fetchThreadWithCursor, __assign(__assign({}, streamParams), { order: order }), undefined, itemsPerFetch)];
            case 3:
                result = _b.sent();
                if (!!result) return [3 /*break*/, 5];
                return [4 /*yield*/, put(
                    // TODO: request does not return error message atm
                    withCursor.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 4:
                _b.sent();
                return [2 /*return*/];
            case 5:
                newStreamParams = __assign(__assign({}, streamParams), { order: order });
                return [4 /*yield*/, all([
                        put(withCursor.actions.initialize({
                            streamId: streamId,
                            streamParams: newStreamParams,
                            itemsPerFetch: itemsPerFetch,
                            items: result.thread,
                            hasMore: result.hasMore,
                            total: result.total,
                            cursor: result.cursor,
                            fetchNextCallback: fetchNextInThread,
                            fetchPreviousCallback: fetchPreviousInThread,
                        })),
                        put(updateCommentsOrder(order)),
                    ])];
            case 6:
                _b.sent();
                if (result.thread.length > 0) {
                    updateCommentOffset(result.thread[0]);
                }
                return [2 /*return*/];
        }
    });
}
function handleThreadUpdate(action) {
    var _a, streamId, result, streamParams, items, newComment, getNewCursor, offset, repliedToItemIndex, offset, lastReplyToParentIndex, repliedToItemIndex, offset, offset;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                _a = action.payload, streamId = _a.streamId, result = _a.result;
                return [4 /*yield*/, call(getStreamParams, streamId)];
            case 1:
                streamParams = _b.sent();
                if (!streamParams) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(selectors.getItems, streamId)];
            case 2:
                items = _b.sent();
                if (!result || !result.comment) {
                    return [2 /*return*/];
                }
                if (!(findIndex(items, { commentId: result.comment.commentId }) !== -1)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(withCursor.actions.replaceItem({
                        streamId: streamId,
                        newItem: result.comment,
                        predicate: { commentId: result.comment.commentId },
                    }))];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                newComment = __assign(__assign({}, result.comment), { isNew: true });
                return [4 /*yield*/, put(actions.setParam({
                        streamId: streamId,
                        paramType: 'lastInsertedCommentId',
                        paramValue: newComment.commentId,
                    }))];
            case 5:
                _b.sent();
                getNewCursor = function (newOffset, comment, stack) {
                    return newOffset >= stack.length ? comment.commentId : undefined;
                };
                if (!(!result.comment.parentId ||
                    parseInt(result.comment.parentId) ===
                        parseInt(streamParams.parentId))) return [3 /*break*/, 7];
                offset = streamParams.order === 'oldest' ? items.length : 0;
                return [4 /*yield*/, put(withCursor.actions.insertItemsAtOffsetAndSetCursor({
                        streamId: streamId,
                        items: [newComment],
                        offset: offset,
                        newCursor: getNewCursor(offset, newComment, items),
                    }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
            case 7:
                if (!(streamParams.order === 'newest')) return [3 /*break*/, 11];
                repliedToItemIndex = findIndex(items, {
                    commentId: result.comment.parentId,
                });
                if (!(repliedToItemIndex === -1)) return [3 /*break*/, 9];
                // The parent isn't in items, so we want to just append this to the start of the comment thread
                // This normally happens on pages dedicated to a specific parent comment
                return [4 /*yield*/, put(withCursor.actions.insertItemsAtOffsetAndSetCursor({
                        streamId: streamId,
                        items: [newComment],
                        offset: 0,
                        newCursor: getNewCursor(0, newComment, items),
                    }))];
            case 8:
                // The parent isn't in items, so we want to just append this to the start of the comment thread
                // This normally happens on pages dedicated to a specific parent comment
                _b.sent();
                return [2 /*return*/];
            case 9:
                offset = repliedToItemIndex + 1;
                return [4 /*yield*/, put(withCursor.actions.insertItemsAtOffsetAndSetCursor({
                        streamId: streamId,
                        items: [newComment],
                        offset: offset,
                        newCursor: getNewCursor(offset, newComment, items),
                    }))];
            case 10:
                _b.sent();
                return [2 /*return*/];
            case 11:
                if (!(streamParams.order === 'oldest')) return [3 /*break*/, 17];
                lastReplyToParentIndex = findLastIndex(items, {
                    parentId: result.comment.parentId,
                });
                if (!(lastReplyToParentIndex === -1)) return [3 /*break*/, 15];
                repliedToItemIndex = findIndex(items, {
                    commentId: result.comment.parentId,
                });
                if (!(repliedToItemIndex === -1)) return [3 /*break*/, 12];
                // The parent isn't in items, so we want to just append this to the start of the comment thread
                // This normally happens on pages dedicated to a specific parent comment
                withCursor.actions.insertItemsAtOffsetAndSetCursor({
                    streamId: streamId,
                    items: [newComment],
                    offset: items.length,
                    newCursor: getNewCursor(items.length, newComment, items),
                });
                return [2 /*return*/];
            case 12:
                offset = repliedToItemIndex + 1;
                return [4 /*yield*/, put(withCursor.actions.insertItemsAtOffsetAndSetCursor({
                        streamId: streamId,
                        items: [newComment],
                        offset: offset,
                        newCursor: getNewCursor(offset, newComment, items),
                    }))];
            case 13:
                _b.sent();
                _b.label = 14;
            case 14: return [3 /*break*/, 17];
            case 15:
                offset = lastReplyToParentIndex + 1;
                return [4 /*yield*/, put(withCursor.actions.insertItemsAtOffsetAndSetCursor({
                        streamId: streamId,
                        items: [newComment],
                        offset: offset,
                        newCursor: getNewCursor(offset, newComment, items),
                    }))];
            case 16:
                _b.sent();
                _b.label = 17;
            case 17: return [2 /*return*/];
        }
    });
}
function handleStreamIdChanged(action) {
    var userOrder, _a, streamId, commentableItemId, commentableTypeId, maxDepth, parentId, _b, order, isInitialized, parentThreadState, _c, streamParams, itemsPerFetch, hasMore, items, noItems;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(getCurrentUserCommentsOrder)];
            case 1:
                userOrder = _d.sent();
                _a = action.payload, streamId = _a.streamId, commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, maxDepth = _a.maxDepth, parentId = _a.parentId, _b = _a.order, order = _b === void 0 ? userOrder : _b;
                if (!streamId) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 2:
                isInitialized = _d.sent();
                if (!!isInitialized) return [3 /*break*/, 7];
                if (!parentId) return [3 /*break*/, 4];
                return [4 /*yield*/, select(getThreadState, commentableTypeId, commentableItemId)];
            case 3:
                _c = _d.sent();
                return [3 /*break*/, 5];
            case 4:
                _c = {};
                _d.label = 5;
            case 5:
                parentThreadState = _c;
                streamParams = {
                    order: order,
                    commentableTypeId: commentableTypeId,
                    commentableItemId: commentableItemId,
                    parentId: parentId,
                    canPostComment: parentThreadState.canPostComment,
                    maxDepth: maxDepth,
                };
                itemsPerFetch = parentThreadState.itemsPerFetch || DEFAULT_ITEMS_PER_FETCH;
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: streamId,
                        streamParams: streamParams,
                        itemsPerFetch: itemsPerFetch,
                        items: [],
                        hasMore: true,
                        fetchNextCallback: fetchNextInThread,
                        fetchPreviousCallback: fetchPreviousInThread,
                    }))];
            case 6:
                _d.sent();
                _d.label = 7;
            case 7: return [4 /*yield*/, select(selectors.hasMore, streamId)];
            case 8:
                hasMore = _d.sent();
                return [4 /*yield*/, select(selectors.getItems, streamId)];
            case 9:
                items = _d.sent();
                noItems = items.length === 0;
                if (!(noItems && hasMore)) return [3 /*break*/, 11];
                return [4 /*yield*/, put(actions.fetchNext(streamId))];
            case 10:
                _d.sent();
                _d.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}
function handleThreadInit(action) {
    var thread, isMobile, defaultMaxDepth, _a, _b, maxDepth, _c, itemsPerFetch, userOrder, commentableTypeId, commentableItemId, parentId, total, items, hasMore, hasLess, canPostComment, _d, order, cursor, prevCursor, streamParams;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                thread = action.payload.thread;
                if (!thread) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsMobile)];
            case 1:
                isMobile = _e.sent();
                defaultMaxDepth = isMobile ? THREAD_MAX_DEPTH_MOBILE : THREAD_MAX_DEPTH;
                _a = action.payload, _b = _a.maxDepth, maxDepth = _b === void 0 ? defaultMaxDepth : _b, _c = _a.itemsPerFetch, itemsPerFetch = _c === void 0 ? DEFAULT_ITEMS_PER_FETCH : _c;
                return [4 /*yield*/, select(getCurrentUserCommentsOrder)];
            case 2:
                userOrder = _e.sent();
                commentableTypeId = thread.commentableTypeId, commentableItemId = thread.commentableItemId, parentId = thread.parentId, total = thread.total, items = thread.items, hasMore = thread.hasMore, hasLess = thread.hasLess, canPostComment = thread.canPostComment, _d = thread.order, order = _d === void 0 ? userOrder : _d, cursor = thread.cursor, prevCursor = thread.prevCursor;
                streamParams = {
                    order: order,
                    commentableTypeId: commentableTypeId,
                    commentableItemId: commentableItemId,
                    parentId: parentId,
                    canPostComment: canPostComment,
                    maxDepth: maxDepth,
                };
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: getStreamId(commentableTypeId, commentableItemId, parentId),
                        groupId: COMMENT_THREAD_STREAM_GROUP_ID,
                        streamParams: streamParams,
                        itemsPerFetch: itemsPerFetch,
                        items: items,
                        hasMore: hasMore,
                        hasLess: hasLess,
                        total: total,
                        cursor: cursor,
                        prevCursor: prevCursor,
                        fetchNextCallback: fetchNextInThread,
                        fetchPreviousCallback: fetchPreviousInThread,
                    }))];
            case 3:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(streamIdChanged, handleStreamIdChanged),
                    takeEvery(initializeThread, handleThreadInit),
                    takeLatest(fetchNextInThread, fetchMoreCommentsWithCursor),
                    takeLatest(fetchPreviousInThread, fetchPreviousComments),
                    takeLatest(changeOrder, switchStreamOrder),
                    takeLatest(threadUpdated, handleThreadUpdate),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map